<script>
import { internationalErrors } from '~/scripts/utils/errors';
import PassengerPicker from '~/components/common/search/passenger-picker';

export default {
    extends: PassengerPicker,
    props: {
        car: {
            type: Number,
            default: 0,
        },
        passengerType: {
            type: String,
            default: '',
        },

        types: {
            type: Array,
            default: () => [
                { text: 'اکونومی کلاس', value: 'economy' },
                { text: 'بیزنس کلاس', value: 'business' },
                { text: 'فرست کلاس', value: 'first' },
            ],
        },
    },
    computed: {
        passengersText () {
            const { adult, child, infant } = this.value;
            const type = (this.types.find(type => type.value === this.type) || {}).text || '';
            return `${adult + child + infant} مسافر، ` + type.replace(' کلاس', '');
        },
    },
    methods: {
        validate ({ adult, child, infant }) {
            if (adult + child + infant > this.maxPassengers) {
                return `حداکثر تعداد مسافران برای پروازهای خارجی ${this.maxPassengers} نفر است.`;
            }
            if (infant + child > adult * 3) {
                return internationalErrors.passengerChildrenLimit;
            }
            if (infant > adult) {
                return internationalErrors.passengerInfantsLimit;
            }
            const msg = PassengerPicker.methods.validate.call(this, { adult, child, infant });
            if (msg) return msg;
            return null;
        },
    },
};

</script>
